/**
 * Base URL for API requests (no trailing slash).
 * In development, default is same-origin `/api/*` (CRA proxy → API).
 * In production, set REACT_APP_API_URL at **build** time unless the host reverse-proxies `/api` to Node.
 * If the proxy fails with “Failed to fetch”, set REACT_APP_API_URL=http://localhost:8787 in frontend/.env
 * and restart `npm start` (CORS on the API must allow your dev origin, e.g. http://localhost:3000, with credentials).
 * Leadership `/admin` routes rely on an HttpOnly cookie from the API — use a dev origin allowed by `CORS_ORIGIN` / LAN rules.
 */
export function getApiBase() {
  const fromEnv = String(process.env.REACT_APP_API_URL || '')
    .trim()
    .replace(/\/$/, '');
  if (process.env.NODE_ENV === 'development') {
    if (fromEnv) return fromEnv;
    return '';
  }
  if (!fromEnv && typeof console !== 'undefined' && typeof window !== 'undefined') {
    console.warn(
      '[ChooseRightCareer] Production build: REACT_APP_API_URL is empty. Browsers call /api on this page’s host. If downloads fail, rebuild with REACT_APP_API_URL=https://your-api-host and set CORS_ORIGIN on the API to your site.',
    );
  }
  return fromEnv;
}

/**
 * Turn browser `TypeError: Failed to fetch` into an actionable message (prod: REACT_APP_API_URL + CORS + HTTPS).
 * @param {string} requestUrl — full URL or path used in `fetch`
 * @param {unknown} err
 */
export function formatApiFetchError(requestUrl, err) {
  const msg = String(err?.message || err);
  if (msg !== 'Failed to fetch' && err?.name !== 'TypeError') return msg;
  return (
    `Cannot reach the API (${requestUrl}). ` +
    `Production: rebuild the frontend with REACT_APP_API_URL=https://your-api-host (no trailing slash), ` +
    `or proxy /api on this host to Node. Ensure api CORS_ORIGIN includes this page’s exact origin (https + host + port). ` +
    `If the API uses https://api.yourdomain and the site is https://yourdomain, production API also merges the apex origin when PUBLIC_API_ORIGIN is set (disable with CORS_DERIVE_WEB_FROM_API=0). ` +
    `Do not mix https pages with http API. (${msg})`
  );
}
